type Collection = List<any> | Dict<any>;

export function sizeOf<TCollection extends Collection>(collection: TCollection): number {
  if ((collection as List<any>).length) return collection.length;
  return Object.keys(collection).length;
}
